import * as React from 'react';
import { createPortal } from 'react-dom';
import { TextField, useMediaQuery } from '@mui/material';
import { SearchBarContainerContext } from 'components/AppBar/AppBar';
import { searchStyles } from './styles';
import './styles.css';

const SearchBar = ({ label = 'Search', setQuery, ...rest }) => {
  const isMobileView = useMediaQuery('(max-width:600px)');
  const { container } = React.useContext(SearchBarContainerContext);

  // When the input value changes, update the query state
  const onInputChange = React.useCallback(event => setQuery(event.target.value), [setQuery]);

  const searchBarInput = (
    <TextField
      label={label}
      value={rest.value}
      sx={searchStyles.searchBarInput}
      onChange={onInputChange}
      InputProps={{
        type: 'search',
      }}
      size={!isMobileView ? 'small' : 'medium'}
    />
  );

  if (!container) {
    return searchBarInput;
  }

  return createPortal(searchBarInput, container);
};

export default SearchBar;
